import { ALERTS_DATA, ALERTS_ERROR, ALERTS_HIDE_ERROR, ALERTS_START_LOADER, ALERTS_STOP_LOADER, } from "../interfaces/iGetAlerts";
const initialState = {
    data: [],
    errorData: { error: null, isOpen: false },
    loader: false,
};
const getAlertsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ALERTS_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case ALERTS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case ALERTS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case ALERTS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case ALERTS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default getAlertsReducer;
